import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { Button } from "components";
const NewAnalysisHeader = ({ onSubmit, isLoading }) => {
  const { t } = useTranslation();
  const { isValid } = useFormikContext();

  const isDisabled = isLoading || !isValid;

  return (
    <div className="header-row space-between">
      <div className="header-title">{t("ActionModal.Mode.NewAnalysis")}</div>
      <div className="header-btn-group">
        <Button
          variant="filled"
          corners="square"
          isLoading={isLoading}
          isDisabled={isDisabled}
          className="action-button"
          onClick={onSubmit}
        >
          {t("ActionModal.SubmitButton")}
        </Button>
      </div>
    </div>
  );
};

export default NewAnalysisHeader;
